import { render, staticRenderFns } from "./editItemReleaseViewList.vue?vue&type=template&id=6a1a8af8&scoped=true"
import script from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
export * from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
import style0 from "./editItemReleaseViewList.vue?vue&type=style&index=0&id=6a1a8af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a8af8",
  null
  
)

export default component.exports